// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer[data-v-ae1b2c9a]{border-top:5px solid var(--g-color-gray-300);padding:1.5rem 0;text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
